<template>
    <div>
        <Toolbar>
            <!-- LEFT -->
            <BackButton :to="__('navigation.dashboard')" :href="$route('dashboard')"/>

            <!-- RIGHT -->
            <template v-slot:right>
                <ToolbarLink
                             :href="$route('connectors.create')">
                    <i class="fas fa-plus-square mr-1"/>
                    {{ __('actions.create_thing', {thing: __('general.connector')}) }}
                </ToolbarLink>
            </template>
        </Toolbar>
        <Card>
            <template v-slot:title>{{ __('general.connector') }}</template>
            <template v-slot:description>
                {{ __('actions.manage_thing', {thing: __('general.connector')}) }}
            </template>
            <div class="table-responsive">
                <table class="table table-vertical-center table-hover">
                    <thead>
                        <tr>
                            <th>Store UUID</th>
                            <th>Kürzel</th>
                            <th>Quelle</th>
                            <th>Import Stock</th>
                            <th class="text-right">{{ __('general.actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="connector in paginatedConnectors.data">
                            <td>
                                {{ connector.store_uuid }}
                            </td>
                            <td>
                                {{ connector.name }}
                            </td>
                            <td>
                                {{ connector.source }}
                            </td>
                            <td>
                                {{ connector.type === 'stock' ? '✔' : 'no' }}
                            </td>
                            <td>
                                <a :href="$route('connectors.edit', [connector.id])">
                                    <TableAction :title="__('actions.edit')">
                                        <i class="fas fa-edit"/>
                                    </TableAction>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- PAGINATION -->
            <Pagination class="mt-3"
                        :pagination="paginatedConnectors"
                        :inertia-options="{only: ['paginatedConnectors']}"
                        disable-when-one-page
            />
        </Card>
    </div>
</template>

<script>
import BackButton from "@components/BackButton.vue";
import Toolbar from "@components/Toolbar.vue";
import ToolbarLink from "@components/ToolbarLink.vue";
import Card from '@components/Cards/Card';
import {PermissionsMixin} from '@js/permissions';
import TableAction from '@components/Table/TableAction';
import Pagination from '@components/TableComponents/Pagination';

export default {
    components: {
        TableAction,
        BackButton,
        Card,
        Toolbar,
        ToolbarLink,
        Pagination,
    },

    mixins: [PermissionsMixin],

    props: {
        paginatedConnectors: Object
    },

    computed: {

    },
}
</script>
